import z from "zod";

import { AppointmentType, FILL_OPTION } from "../scheduling";
import {
  BANNER_VARIANTS,
  EnterInsuranceInfo,
  LINK_TYPES,
  NIRVANA_VARIANTS,
} from "./constants";

export const BOOKING_PAGE_VIEWS = {
  PROVIDER_VIEW: "provider_view",
  FIRST_AVAILABLE_VIEW: "first_available_view",
};

const bookingPageViewSchema = z.enum(
  Object.values(BOOKING_PAGE_VIEWS) as [string, ...string[]],
);

const linkTypeSchema = z.enum(
  Object.values(LINK_TYPES) as [string, ...string[]],
);

export const startBookingFlowSchema = z.object({
  appointmentType: AppointmentType,
  linkType: linkTypeSchema.optional(),
});

export const bookingFlowSchema = z
  .object({
    id: z.string(),
  })
  .extend(startBookingFlowSchema.shape);

export const storeSlotDateViewSchema = z.object({
  id: z.string(),
  slotDateViewed: z.string(),
  providers: z
    .array(z.object({ id: z.number(), slotCount: z.number().int().min(0) }))
    .min(1),
});

export const updateBookingFlowSchema = z.object({
  id: z.string(),
  scheduleEntryPage: bookingPageViewSchema.optional(),
  scheduleContinuationPage: bookingPageViewSchema.optional(),
  insurancePageViewedAt: z.string().datetime().optional(),
  insurancePageSubmittedAt: z.string().datetime().optional(),
  emailExitPageViewedAt: z.string().datetime().optional(),
  emailExitPageSubmittedAt: z.string().datetime().optional(),
  schedulingPageViewedAt: z.string().datetime().optional(),
  appointmentSlotSubmittedAt: z.string().datetime().optional(),
  emailContinuePageViewedAt: z.string().datetime().optional(),
  patientInfoPageViewedAt: z.string().datetime().optional(),
  providerId: z.number().optional(),
  selectedAppointmentSlot: z.string().datetime().optional(),
  stateId: z.number().nullable().optional(),
  insuranceId: z.number().nullable().optional(),
  isOtherState: z.boolean().optional(),
  isNotListedInsurance: z.boolean().optional(),
  enterInsuranceInfo: z
    .enum(
      Object.values(FILL_OPTION) as [
        EnterInsuranceInfo,
        ...EnterInsuranceInfo[],
      ],
    )
    .optional(),
  interstitialVariant: z.string().optional(),
  interstitialGoalSelections: z.array(z.string()).optional(),
  interstitialQuestionPageViewedAt: z.string().datetime().optional(),
  interstitialQuestionPageSubmittedAt: z.string().datetime().optional(),
  interstitialInfoPageViewedAt: z.string().datetime().optional(),
  interstitialInfoPageSubmittedAt: z.string().datetime().optional(),
  nirvanaVariant: z
    .enum(Object.values(NIRVANA_VARIANTS) as [string, ...string[]])
    .optional(),
  demographicInfoPageViewedAt: z.string().datetime().optional(),
  demographicInfoPageSubmittedAt: z.string().datetime().optional(),
  nirvanaLoadingScreenViewedAt: z.string().datetime().optional(),
  bannerVariant: z
    .enum(Object.values(BANNER_VARIANTS) as [string, ...string[]])
    .optional(),
});
